define('views/modules/calendar/animated-session/animation/animation-detail-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // services
    'services/external-video',
    // models
    'models/calendar/session/animation',
    // views
    'views/parts/modal/modal',
    // templates
    'text!templates/modules/calendar/animated-session/animation/animation-detail-modal.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    ExternalVideo,
    // models
    MAnimation,
    // views
    VModal,
    // templates
    TAnimationDetailModal
) {

    var VAnimationDetailModal = VModal.extend({
        template: TAnimationDetailModal,
        modal: function() {
            return {
                title: this.model.get("name"),
                className: "animation-detail-modal",
                onEscape: true,
            };
        },
        buttons: _.noop,

        regions: {
            externalVideo: '.external-video',
            externalVideoThumbnail: '.external-video-thumbnail',
            videoThumbnailImg: '.video-thumbnail-img',
            videoPlayOverlay: '.video-play-overlay'
        },

        initialize: function(options) {
            options = options || {}; // additional options passed to the constructor.
            var model = this.model = new MAnimation();
            this.setModel(model);
        },

        render: function() {
            var model = this.model,
                html = Mustache.render(this.template, Mustache.getContext(
                  _.extend(model.toJSON(), {
                                      showTCNotes: this.showTCNotes,
                                      notes: this.notes
                                      }
                                    )));

            this.$el.empty().append(html);

            this.generateZones();

            this.renderModal();

            return this;
        },

        setTCNotesDisplay: function(showTCNotes, notes) {
            this.showTCNotes = showTCNotes;
            this.notes = notes;
            return this;
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            return this;
        },

        setExternalVideoUrl: function() {
            var self = this;
            ExternalVideo.setProviderFromUrl(this.model.get('animationUrl'));
            ExternalVideo.setVideoId();

            console.log('[AnimationDetailModal] setExternalVideoUrl called');
            console.log('[AnimationDetailModal] isNativeApp:', ExternalVideo.isNativeApp());

            // On native apps, show thumbnail with play button instead of iframe
            if (ExternalVideo.isNativeApp()) {
                console.log('[AnimationDetailModal] Native app detected, showing thumbnail');
                // Hide iframe, show thumbnail with play button
                this.zone.$externalVideo.hide();
                this.zone.$externalVideoThumbnail.show();

                // Set thumbnail image
                var thumbnailUrl = ExternalVideo.get('thumbnailUrl');
                console.log('[AnimationDetailModal] Thumbnail URL:', thumbnailUrl);
                this.zone.$videoThumbnailImg.attr('src', thumbnailUrl);

                // Add click handler to open InAppBrowser
                this.zone.$externalVideoThumbnail.off('click').on('click', function() {
                    console.log('[AnimationDetailModal] Thumbnail clicked, opening InAppBrowser');
                    ExternalVideo.openInAppBrowser();
                });
            } else {
                console.log('[AnimationDetailModal] Web browser, using iframe embed');
                this.zone.$externalVideo.attr('src', ExternalVideo.getEmbedUrl());
            }
        },

        onShown: function() {
            if (this.model.hasExternalVideo()) {
                this.setExternalVideoUrl();
            }
        },
    });

    return VAnimationDetailModal;

});

